import { authService } from "@/services/auth.service";
import { Callback } from "@/types/types";
import Cookie from "js-cookie";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import Template from "./Callback.template.vue";

const namespace: string = "authModule";

@Component({
  mixins: [Template]
})
export default class CallbackComponent extends Vue {
  public code: string = "";
  public isLoading: boolean = true;
  @Action("getByToken", { namespace })
  private getByTokenAction!: Callback;
  public async mounted() {
    this.code = String(this.$route.query!.code);
    if (this.code) {
      await authService.getToken(this.code);
      const ref = Cookie.get("referrer_app");
      if (ref) {
        window.location.href = ref;
        return;
      }
      await this.getByTokenAction();
      this.$router.push("/dashboard");
    }
  }
}
